import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {catchError, map, mergeMap, switchMap, tap} from 'rxjs/operators';
import * as BillingActions from './billing.actions';
import { BillingService } from "../../services/billing.service";

@Injectable()
export class BillingEffects {
  constructor(
    private actions$: Actions,
    private billingService: BillingService
  ) {}

  billingPortal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BillingActions.billingPortal),
      // tap(() => console.log('Billing portal effect triggered')),
      switchMap(action =>
        this.billingService.billingPortal(action.userId).pipe(
          tap(() => console.log('Calling billing portal service', action.userId)),
          map(data => {
            if (!data) {
              throw new Error('Invalid billing portal response');
            }
            console.log('Billing portal successful', data);
            return BillingActions.billingPortalSuccess({ data });
          }),
          catchError(error => {
            console.log('Billing portal failed', error);
            return of(BillingActions.billingPortalFailure({ error }));
          })
        )
      )
    )
  );

  loadBillings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BillingActions.loadBillings),
      // tap(() => console.log('Load billings effect triggered')),
      switchMap(({userId, page}) =>
        this.billingService.fetchBillings(userId, page).pipe(
          tap(data => {
            if (!data) {
              throw new Error('Invalid load billings response');
            }
            // console.log('Load billings successful', data);
          }),
          map(data => BillingActions.loadBillingsSuccess({ data })),
          catchError(error => {
            console.log('Load billings failed', error);
            return of(BillingActions.loadBillingsFailure({ error }));
          })
        )
      )
    )
  );

  loadInvoice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BillingActions.loadInvoice),
      // tap(action => console.log('Loading invoice:', action.invoiceId)),
      switchMap(action =>
        this.billingService.fetchInvoice(action.invoiceId).pipe(
          // tap(data => console.log('Invoice loaded successfully', data)),
          map(data => BillingActions.loadInvoiceSuccess({ data })),
          catchError(error => {
            console.error('Failed to load invoice', error);
            return of(BillingActions.loadInvoiceFailure({ error }));
          })
        )
      )
    )
  );

}
